<template>
  <v-card width="350">
    <v-col align="center">
      <h3 class="mt-5 mb-2" align="center">Паспорт автополива</h3>

      <v-row v-if="properties">
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">ID объекта</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.id }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Общая площадь</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="total_area"
              type="number"
              step="0.01"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Диаметр трубы</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="pipe_diameter"
              type="number"
              step="0.01"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Ответственная организация</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_serviceorganization"
              v-model="service_organization_id"
              item-text="name"
              item-value="id"
              placeholder="Организация"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">График полива</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_watering_schedule"
              v-model="watering_schedule_id"
              item-text="name"
              item-value="id"
              placeholder="График"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Источник</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_source"
              v-model="source_id"
              item-text="name"
              item-value="id"
              placeholder="Источник"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Дата установки</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu v-model="installationDateMenu" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="installation_date"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  hide-details
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker v-model="installation_date" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <div class="mt-2">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-card-text class="text-end">
              <v-btn type="button" class="font-weight-bold" @click="saveClick"
              >Сохранить</v-btn
              >
            </v-card-text>
          </v-col>
          <v-col v-if="isDraw" cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn type="button" class="font-weight-bold" @click="clearData"
            >Очистить</v-btn
            ></v-card-text
            >
          </v-col>
          <v-col v-else cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn
                type="button"
                class="font-weight-bold"
                @click="deleteClick"
            >Удалить</v-btn
            ></v-card-text
            >
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-card>
</template>

<script>
import Vue from "vue";
import {URL_API} from "@/settings/apiConnect";

export default {
  name: "IrrigationPassport",

  props: {
    saveIrrigation: Function,
    deleteIrrigation: Function,
    properties: Object,
    isDraw: Boolean
  },

  data() {
    return {
      installationDateMenu: false,
      passport_serviceorganization: [],
      passport_watering_schedule: [],
      total_area: null,
      pipe_diameter: null,
      service_organization_id: null,
      watering_schedule_id: null,
      installation_date: null,
      source_id: null,
    };
  },

  computed: {
    passport_source() {
      return this.$store.state.sources.sourcesData;
    },
  },

  methods: {
    saveClick() {
      const irrigationData = {
        total_area: this.total_area,
        pipe_diameter: this.pipe_diameter,
        service_organization_id: this.service_organization_id,
        watering_schedule_id: this.watering_schedule_id,
        installation_date: this.installation_date,
        source_id: this.source_id,
      };

      this.saveIrrigation(irrigationData);
    },
    deleteClick() {
      this.deleteIrrigation();
    },

    clearData() {
      this.total_area = null;
      this.pipe_diameter = null;
      this.service_organization_id = null;
      this.watering_schedule_id = null;
      this.installation_date = null;
      this.source_id = null;
    }
  },

  async mounted() {
    let response = await Vue.axios.get(`${URL_API}serviceorganization`);
    this.passport_serviceorganization = response.data;

    response = await Vue.axios.get(`${URL_API}cleaningschedule`);
    this.passport_watering_schedule = response.data;

    if (this.properties?.id) {
      response = await Vue.axios.get(
          `${URL_API}irrigationsystem/view/${this.properties.id}`
      );
      const data = response.data;
      console.log("данные автополива", data);
      this.total_area = data.total_area;
      this.pipe_diameter = data.pipe_diameter;
      this.service_organization_id = data.service_organization_id;
      this.watering_schedule_id = data.watering_schedule_id;
      this.installation_date = data.installation_date;
      this.source_id = data.source_id;
    }
  },
};
</script>

<style scoped>
.v-card-text {
  font-size: 14px;
}
.v-text-field,
.v-select {
  font-size: 14px;
}
</style>